import type { Image } from "@prisma/client";
import createDbEntityDeserializer from "~/kernel/server/createDbEntityDeserializer";

const deserializeImage = createDbEntityDeserializer<Image>();

export default deserializeImage;
